// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"316":"b18252ed","453":"364b1989","455":"e6b05234","868":"331eacf3","977":"903f856e"}[chunkId] + ".chunk.js";
};